import Stack from "@mui/material/Stack";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import Select from "shared/components/Form/Select";
import TextField from "shared/components/Form/TextField";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { useLanguageDetails } from "../../context";
import DashboardLink from "../DashboardLink";

const LanguageDetailsContent = () => {
  const {
    displayNameInput,
    generalTranslationIdInput,
    gameNameTranslationIdInput,
    selectedLanguage,
    setSelectedLanguage,
    isDisabledLanguageSelection,
    shouldHideAssistantFields,
    existedLanguages,
    allLanguageOptions,
  } = useLanguageDetails();

  const languageOptions = allLanguageOptions.filter(
    (lang) =>
      !existedLanguages.includes(lang.value) ||
      lang.value === selectedLanguage.value,
  );

  return (
    <>
      <ContentSection title="General">
        <Stack spacing="1rem">
          <Select
            id="languageCode"
            label="Language code*"
            placeholder="Select language"
            fullWidth
            value={selectedLanguage.value}
            options={languageOptions}
            onChange={(e) => {
              const language = allLanguageOptions.find(
                (option) => option.value === e.target.value,
              );

              setSelectedLanguage({
                label: language?.label || "",
                value: language?.value || "",
              });
            }}
            disabled={isDisabledLanguageSelection}
          />
          <TextField
            id="displayName"
            label="Display name*"
            placeholder="Enter display name"
            fullWidth
            required
            value={displayNameInput.input.value}
            onChange={(e) => displayNameInput.setValue(e.target.value)}
            error={displayNameInput.input.errors.length > 0}
          />
          {!shouldHideAssistantFields && (
            <>
              <FlexColumn
                sx={{
                  position: "relative",
                }}
              >
                <DashboardLink
                  assistantId={generalTranslationIdInput.input.value}
                />
                <TextField
                  id="generalTranslationId"
                  label="General translation ID"
                  fullWidth
                  placeholder="General translation ID"
                  required
                  value={generalTranslationIdInput.input.value}
                  disabled
                />
              </FlexColumn>
              <FlexColumn
                sx={{
                  position: "relative",
                }}
              >
                <DashboardLink
                  assistantId={gameNameTranslationIdInput.input.value}
                />
                <TextField
                  id="gameNameTranslationId"
                  label="Game name translation ID"
                  fullWidth
                  placeholder="Game name translation ID"
                  required
                  value={gameNameTranslationIdInput.input.value}
                  disabled
                />
              </FlexColumn>
            </>
          )}
        </Stack>
      </ContentSection>
    </>
  );
};

export default LanguageDetailsContent;
